/* @flow */
import { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    maxHeight: '80vh !important',
  },
  title: {
    textAlign: 'left',
    padding: [34, 15],
    margin: 0,
  },
  content: {
    height: '100%',
    overflowY: 'auto',
    padding: [0, 15, 34, 15],
  },
  item: {
    paddingBottom: 22,
    marginBottom: 36,
    borderBottom: ({ theme }: ThemeFunction) =>
      `1px solid ${theme.secondaryTagColor}`,
  },
};
